import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculatorResult, MonthlyResult } from '../../../../models/analysis/solar-calculator-result';
import * as dayjs from 'dayjs';
import { LanguageService } from '../../../../../services/language.service';
import { UnsubscribeOnDestroyAdapter } from '../../../../adapters/unsubscibe-on-destroy.adapter';

@Component({
  selector: 'psc-month-selector',
  templateUrl: './month-selector.component.html'
})
export class MonthSelectorComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  public calculatorResultValue: CalculatorResult;

  get solarCalculatorResult() {
    return this.calculatorResultValue;
  }

  @Input()
  set solarCalculatorResult(value: CalculatorResult) {
    this.calculatorResultValue = value;
    if (!value) {
      return;
    }
    this.onInputDataChange();
  }

  @Output() monthChanged: EventEmitter<number> = new EventEmitter<number>();

  monthsLocalized: string[];

  selectedMonth: number = 0;
  currentMonthlyResult: MonthlyResult;
  sortedValues: MonthlyResult[];
  startingMonth: number;
  selectedIndex = 0;

  constructor(
    protected languageService: LanguageService,
  ) {
    super();
  }


  ngOnInit() {
    this.setMonths();
    this.subs.sink = this.languageService.languageChanged$.subscribe(() => {
      this.setMonths();
    });
  }

  setMonths() {
    this.monthsLocalized = dayjs.months();
  }

  protected onInputDataChange() {

    const monthlyValues = this.solarCalculatorResult.monthlyResult;

    const year = +monthlyValues[0].year;
    const lastYearIndex = monthlyValues.findIndex((result) => +result.year < year);

    this.sortedValues = lastYearIndex > -1 ? [...monthlyValues.slice(lastYearIndex), ...monthlyValues.slice(0, lastYearIndex)] : monthlyValues;
    this.startingMonth = lastYearIndex > -1 ? lastYearIndex : 0;
    this.selectedIndex = 0;
    this.currentMonthlyResult = this.sortedValues[this.selectedIndex];
    this.emitSelectedMonth();
  }

  monthChange(direction: 1 | -1) {
    if ((this.selectedIndex === 0 && direction === -1) || (this.selectedIndex === 11 && direction === 1)) {
      return;
    }

    this.selectedIndex += direction;
    this.currentMonthlyResult = this.sortedValues[this.selectedIndex];
    this.emitSelectedMonth();
  }

  emitSelectedMonth() {
    this.selectedMonth = (this.startingMonth + this.selectedIndex) % 12;
    this.monthChanged.emit(this.selectedMonth);
  }

}
